<script>
export default {
    name: 'IconArrowDown'
}
</script>
<template>
    <svg
        class="base-icon icon-arrow-down"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M56 32.03L32.1 56l-.1-.1-.1.1L8 32.03l4.218-4.23 16.8 16.848V8h5.964l.001 36.648 16.8-16.849z"
            fill-rule="evenodd"
        />
    </svg>
</template>
